/**
 * EIP-712 typed-data for a REAL whole-parcel Marketplace ORDER (Macro #29).
 *
 * BYTE-IDENTICAL to the backend `eip712.order_hash` and the frozen Stage-1
 * `TheGridMarketplace` ORDER_TYPEHASH:
 *   domain  = ("TheGridMarketplace", "1", chainId, verifyingContract)
 *   Order(address seller,address collection,uint256 tokenId,address currency,
 *         uint256 price,uint256 listingVersion,uint256 nonce,uint256 expiryRealTs)
 *
 * Pure + deterministic → cross-verified against the backend digest in tests.
 * The frontend is NEVER authority: the backend re-derives this digest and
 * re-verifies the signature (EOA/ERC-1271/ERC-6492/EIP-7702) fail-closed.
 */

export const ORDER_PRIMARY_TYPE = "Order" as const;

export const ORDER_EIP712_TYPES = {
  Order: [
    { name: "seller", type: "address" },
    { name: "collection", type: "address" },
    { name: "tokenId", type: "uint256" },
    { name: "currency", type: "address" },
    { name: "price", type: "uint256" },
    { name: "listingVersion", type: "uint256" },
    { name: "nonce", type: "uint256" },
    { name: "expiryRealTs", type: "uint256" },
  ],
} as const;

export interface WholeParcelOrder {
  seller: `0x${string}`;
  collection: `0x${string}`;
  tokenId: bigint;
  currency: `0x${string}`;
  price: bigint;
  listingVersion: bigint;
  nonce: bigint;
  expiryRealTs: bigint;
}

export function buildOrderTypedData(args: {
  chainId: number;
  verifyingContract: `0x${string}`;
  order: WholeParcelOrder;
}) {
  return {
    domain: {
      name: "TheGridMarketplace",
      version: "1",
      chainId: args.chainId,
      verifyingContract: args.verifyingContract,
    },
    types: ORDER_EIP712_TYPES,
    primaryType: ORDER_PRIMARY_TYPE,
    message: { ...args.order },
  } as const;
}
